/* eslint-disable */
var layerActions = require('./nav-mobile-actions');

// MOBILE NAVIGATION TOOLBAR INIT
module.exports.init = function() {

  // Add body class to announce toolbar is present.
  cube.$('body').classList.add('has-navigation-toolbar');
  cube.$$('.layer-container__close').on('click', layerActions.closeLayer);
  cube.$$('.dkt-toolbar__item').on('click', function(e) {
    var item = e.target;
    if (!item.classList.contains('dkt-toolbar__item')) {
      item = item.closest('.dkt-toolbar__item');

      if (item.classList.contains('dkt-toolbar__item--active')) {
        layerActions.closeLayer();
      } else {
        openLayer(item);
      }
    }
  });
  // cube.$$('.dkt-toolbar__item--active').on('click', layerActions.closeLayer);

  if (tc_vars.page_name === '/home') {
    cube.$id('homeToolbarItem').classList.add('dkt-toolbar__item--active');
  }
  if (tc_vars.env_template === 'product') {
    var toolbar = cube.$('.dkt-toolbar');
    if (toolbar.dataset.show === 'false' && document.querySelector('body').classList.contains('has-navigation-toolbar')) {
      toolbar.style.display = 'none';
    }
  }
};

// Generic " Open Layer " method
var openLayer = function(elt) {
  /* var el = elt.target;
  if (!el.classList.contains('dkt-toolbar__item')) {
    el = el.closest('.dkt-toolbar__item');
  } */
  var layerName = elt.dataset.layer;
  var layerTitle = elt.dataset.layerTitle;
  // Get related layer-opening action
  var openAction = layerActions.list[layerName];
  // If layer-opening action is defined : execute it
  if (openAction && typeof openAction == 'function') {
    openAction(elt);
  }
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/nav-mobile-toolbar.js